import { render, staticRenderFns } from "./SingleLayerElement.vue?vue&type=template&id=1bd249da&scoped=true"
import script from "./SingleLayerElement.vue?vue&type=script&lang=ts"
export * from "./SingleLayerElement.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SingleLayerElement.vue?vue&type=style&index=0&id=1bd249da&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1bd249da",
  null
  ,true
)

export default component.exports